export const contractorsListingRoutes = [
  {
    path: 'listing',
    name: 'contractors-listing',
    component: () =>
      import(/* webpackChunkName: "Contractors-listing" */ './ContractorsListing.vue')
  },
  {
    path: 'create',
    name: 'create-contractor',
    component: () =>
      import(/* webpackChunkName: "new-contractor" */ '../../../contractors/features/new-contractor/NewContractor.vue')
  }
];
